import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import { nanoid } from 'nanoid';

const DirectReportsSelections = ({
	selected,
	setSelected,
	directReports,
	setDirectReports,
	formik = null,
}) => {
	const handleDeselect = staffMember => {
		//add staff member to direct reports
		let updatedDirectReports = [...directReports];
		updatedDirectReports.push(staffMember);

		//remove staff member from selected
		let updatedSelected = [...selected].filter(
			x => x.fiId !== staffMember.fiId
		);

		//remove staff member from validated staff members
		let updatedValidatedStaffMembers = [
			...formik.values.validatedStaffMembers,
		].filter(x => x.fiId !== staffMember.fiId);

		//set state
		if (formik) {
			formik.setFieldValue('staffMembersForReview', [...selected]);
			formik.setFieldValue(
				'validatedStaffMembers',
				updatedValidatedStaffMembers
			);
		}
		setDirectReports(updatedDirectReports);
		setSelected(updatedSelected);
	};

	return (
		<>
			{selected.length > 0 ? (
				<Paper
					sx={{
						display: 'flex',
						justifyContent: 'center',
						flexWrap: 'wrap',
						listStyle: 'none',
						p: 0.5,
						m: 0,
					}}
					component='ul'
				>
					{selected.map(staffMember => {
						return (
							<li key={nanoid()}>
								<Chip
									label={
										staffMember.lastName +
										', ' +
										staffMember.firstName
									}
									onDelete={() => handleDeselect(staffMember)}
									id={
										'STAFF_MEMBER_DESELECT_' +
										staffMember.fiId
									}
								/>
							</li>
						);
					})}
				</Paper>
			) : null}
		</>
	);
};

export default DirectReportsSelections;
